
import Menu from "../../components/globalComponents/headerMenu/menu"

import SocialIcons from "../../components/globalComponents/socialIcons/socialIcons";
import GradientLine from "../../components/globalComponents/gradientLine/gradientLine";
import Footer from "../../components/globalComponents/footer/footer";

import "./contactPage.scss"

import ContactComponent from "../../components/contactComponent/contactComponent";
import InfocontactComponent from "../../components/contactComponent/infocontactComponent/infocontactComponent";
import LocationCompany from "../../components/contactComponent/locationCompany/locationCompany";


const ContactPage = () => {
    

    return(
        <div>
            <Menu />
            <ContactComponent/>
            <hr className="divider diverdermedia diverdermedia-none" />
            <InfocontactComponent/>
            <hr className="divider diverdermedia" />
            <LocationCompany/>
            <SocialIcons />
            <GradientLine />
            <Footer />
            
        </div>
        
    )
}

export default ContactPage;